module.exports = __webpack_public_path__ + "static/media/font_medium.74279da5.woff";